import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../../../Redux/AlertReducer";
import { api_Routes } from "../../../../../tools/api_Routes";
import { Helper } from "../../../../../tools/Helper";
import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

const FormEditWhatsappGroup = ({ data, setData, Panels }) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const itemsPerPage = 25;

  // Panels State
  const [panelsPage, setPanelsPage] = useState(1);
  const [panelSearchQuery, setPanelSearchQuery] = useState("");
  const paginatedPanels = Panels.slice(0, panelsPage * itemsPerPage);
  const filteredPanels = Panels.filter((panel) =>
    panel.name.toLowerCase().includes(panelSearchQuery.toLowerCase())
  );
  const displayedPanels = panelSearchQuery ? filteredPanels : paginatedPanels;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePanelChange = (event, value) => {
    setData((prev) => ({
      ...prev,
      owner_panel: value.id || "",
    }));
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    try {
      const { result, response, message } = await Helper.Put({
        url: api_Routes.Groups.Whatsapp.Edit + id,
        data: {
          ...data,
        },
      });
      setIsLoading(false);
      if (response) {
        setErrors("");
        dispatch(setSuccess(true));
        console.log("Form submission successful:", response);
        navigate("/WhatsappGroups");
      } else {
        setErrors(message);
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col justify-between items-center gap-x-6 md:flex-row">
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          autoComplete="off"
          value={data?.title}
          onChange={handleInputChange}
          variant="outlined"
        />
        <div className="w-full">
          <Autocomplete
            disablePortal
            options={displayedPanels}
            value={
              Panels.find((panel) => panel.id == data?.owner_panel) || null
            }
            getOptionLabel={(option) => option.name || ""}
            onChange={handlePanelChange}
            onInputChange={(event, value) => setPanelSearchQuery(value)}
            renderInput={(params) => (
              <TextField {...params} label="Panel" variant="outlined" />
            )}
            ListboxProps={{
              onScroll: (event) => {
                const listboxNode = event.currentTarget;
                if (
                  listboxNode.scrollTop + listboxNode.clientHeight >=
                  listboxNode.scrollHeight - 3
                ) {
                  setPanelsPage((prevPage) => prevPage + 1);
                }
              },
            }}
          />
        </div>
      </div>

      <div className="flex flex-col justify-between items-start gap-x-6 md:flex-row">
        <TextField
          fullWidth
          margin="normal"
          label="URL"
          name="url"
          required
          autoComplete="off"
          value={data?.url}
          onChange={handleInputChange}
          variant="outlined"
          error={!!errors}
          helperText={errors}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Owner"
          name="owner"
          required
          autoComplete="off"
          value={data?.owner}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>

      <div className="w-full flex items-center justify-start gap-x-3">
        <FormLabel sx={{ fontWeight: "bold" }} component="legend">
          active :
        </FormLabel>
        <RadioGroup
          name="active"
          value={data?.active}
          onChange={handleInputChange}
          row
        >
          <FormControlLabel value="1" control={<Radio />} label="Yes" />
          <FormControlLabel value="0" control={<Radio />} label="No" />
        </RadioGroup>
      </div>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        disabled={isLoading}
        sx={{
          display: "flex",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
        }}
      >
        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
      </Button>
    </form>
  );
};

export default FormEditWhatsappGroup;
